export enum IntegrationType {
    Reddit = 'reddit',
}
export interface Integration {
    integrationType: IntegrationType;
    status: 'connected' | 'disconnected';
}